export const getAssetFormat = (mimeType?: string) => {
  if (!mimeType) return "";
  return mimeType.split("/").pop();
};
